import { PUT } from '../../../redux/middleware/types'
import backendRequest from '../../../services/api/backendRequest'
import budgetingMethodEndpoints from '../api/budgetingMethodEndpoints'
import { BudgetingMethodData } from '../types'

/**
 * Update budgeting method for an income statement row
 */
export const updateBudgetingMethod = async (
  data: BudgetingMethodData,
  companyId: string,
  budgetingScenarioId?: number | null
): Promise<BudgetingMethodData> => {
  return backendRequest<BudgetingMethodData>({
    method: PUT,
    url: budgetingMethodEndpoints.list(companyId),
    params: {
      budgetingScenarioId
    },
    data
  })
}
